module.exports = __webpack_public_path__ + "twitter.png?73aa51379e5f0204183222026f75e380";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/twitter.png
// module id = 191
// module chunks = 0